import * as yup from 'yup';

import { emailRequiredValidator } from '@mopla/utils';

const LoginValidationSchema = yup.object().shape({
	email: emailRequiredValidator(),
	password: yup.string().required('password.required'),
});

export default LoginValidationSchema;
